import { ClerkProvider, SignedIn, SignedOut, SignIn } from '@clerk/clerk-react';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { queryClient } from '@/lib/queryClient';
import { router } from '@/router';
import { config } from '@/config';
import { AppProvider, useAppContext } from '@/context/AppContext';
import { ClerkSync } from '@/context/ClerkSync';
import { PlatformAdminProvider } from '@/context/PlatformAdminContext';
import { DevBadge } from '@/layouts/DevBadge';

function AppShell() {
  const { mockupMode } = useAppContext();

  if (mockupMode) {
    return (
      <QueryClientProvider client={queryClient}>
        <PlatformAdminProvider>
          <RouterProvider router={router} />
        </PlatformAdminProvider>
        <DevBadge />
      </QueryClientProvider>
    );
  }

  if (!config.clerkPublishableKey) {
    throw new Error('VITE_CLERK_PUBLISHABLE_KEY is required when not in mockup mode');
  }

  return (
    <ClerkProvider publishableKey={config.clerkPublishableKey}>
      <QueryClientProvider client={queryClient}>
        <SignedIn>
          <ClerkSync>
            <PlatformAdminProvider>
              <RouterProvider router={router} />
            </PlatformAdminProvider>
          </ClerkSync>
        </SignedIn>
        <SignedOut>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 'var(--space-12)',
              gap: 'var(--space-4)',
            }}
          >
            <SignIn />
          </div>
        </SignedOut>
        <DevBadge />
      </QueryClientProvider>
    </ClerkProvider>
  );
}

export function App() {
  return (
    <AppProvider>
      <AppShell />
    </AppProvider>
  );
}
